export const launchAppCreatorMode = (observationId) => {
  const domain = window.location.hostname;
  const token = localStorage.getItem('accessToken');
  const observationIdParam = observationId ? `&observationId=${observationId}` : '';

  window.location.assign(`mediphany:${domain}?token=${token}&creatorMode=1${observationIdParam}`);
};

export default {
  launchAppCreatorMode,
};
